import { RightOutlined } from '@ant-design/icons';
import { translate } from '@portal/services/i18n';
import { pix } from '@portal/config/app.json';
import React from 'react';
import CurrencyInputMask from 'react-currency-input';
import ThemedText from '@portal/components/ThemedText/ThemedText';

interface GenerateBilletAmountProps {
  billetAmount: string;
  setBilletAmount: (value: string) => void;
  setBilletRawAmount: (value: number) => void;
  onSubmit: (willSpecifyValue?: boolean) => void;
  receiveType?: 'billet' | 'qrCode';
  autoFocus?: boolean;
}

const GenerateBilletAmount = ({
  billetAmount,
  setBilletAmount,
  setBilletRawAmount,
  onSubmit,
  receiveType,
  autoFocus = true,
}: GenerateBilletAmountProps) => {
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onSubmit();
  };

  return (
    <div className="generate-billet-amount">
      {receiveType === 'billet' && (
        <ThemedText variant="body" className="generate-billet-amount__text">
          {translate('PAGES.HOME.BILLET_AND_PIX_VALUE.TITLES.BILLET')}
        </ThemedText>
      )}
      {receiveType === 'qrCode' && (
        <ThemedText variant="body" className="generate-billet-amount__text">
          {translate('PAGES.HOME.BILLET_AND_PIX_VALUE.TITLES.QRCODE')}
        </ThemedText>
      )}
      {!receiveType && (
        <ThemedText variant="body" className="generate-billet-amount__text">
          {translate('PAGES.HOME.BILLET_AND_PIX_VALUE.TITLES.PAY')}
        </ThemedText>
      )}
      <form onSubmit={handleSubmit}>
        <CurrencyInputMask
          autoFocus={autoFocus}
          value={billetAmount}
          onChange={(value, rawValues) => {
            setBilletRawAmount(rawValues ?? 0);
            setBilletAmount(value ?? '0');
          }}
          thousandSeparator={translate('SHARED.CURRENCY.THOUSAND_SEPARATOR')}
          decimalSeparator={translate('SHARED.CURRENCY.DECIMAL_SEPARATOR')}
          prefix={translate('SHARED.CURRENCY.SYMBOL')}
          className="generate-billet-amount__currency-mask-input"
        />
      </form>
      {pix.pixQrCodeAmountNotSpecified && receiveType === 'qrCode' ? (
        <ThemedText
          variant="body"
          className="generate-billet-amount__text generate-billet-amount__no-value"
          onClick={() => {
            setBilletRawAmount(0);
            onSubmit(false);
          }}
        >
          {translate('PAGES.HOME.BILLET_AND_PIX_VALUE.TITLES.NO_VALUE')}
          <span>
            <RightOutlined />
          </span>
        </ThemedText>
      ) : null}
    </div>
  );
};

export default GenerateBilletAmount;
